import { Grid, GridColumn } from '@progress/kendo-react-grid';
import React, { useState } from 'react';
import { locale } from '../../../common/localization/localizationService';
import { process } from '@progress/kendo-data-query';

export interface IRoutesImportGridProps {
  data: Array<any>;
}

export default function RoutesImportGrid(
  props: IRoutesImportGridProps,
): JSX.Element {
  const [dataState, setDataState] = useState({
    sort: [{ dir: 'asc', field: locale.routeAdminPage._sequence }],
  });

  const dataStateChange = (event: any) => {
    setDataState(event.data);
  };
  const gridData = props.data.map((routeStop) => {
    return routeStop;
  });
  const result = process(gridData, dataState);

  return (
    <>
      <Grid
        {...dataState}
        className={`route-stop-import-grid`}
        data={result}
        selectedField="selected"
        resizable
        onDataStateChange={dataStateChange}
        sortable
      >
        <GridColumn
          field={locale.routeAdminPage._route}
          title={locale.routeAdminPage._route}
          sortable
        />
        <GridColumn
          field={locale.routeAdminPage._sequence}
          title={locale.routeAdminPage._sequence}
          sortable
        />
        <GridColumn
          field={locale.routeAdminPage._degLat}
          title={locale.routeAdminPage._degLat}
          sortable
        />
        <GridColumn
          field={locale.routeAdminPage._degLong}
          title={locale.routeAdminPage._degLong}
          sortable
        />
        <GridColumn
          field={locale.routeAdminPage._agreementLineId}
          title={locale.routeAdminPage._agreementLineId}
          sortable
        />
        <GridColumn
          field={locale.routeOverview._system}
          title={locale.routeOverview._system}
          sortable
        />
      </Grid>
    </>
  );
}
